import clsx from 'clsx';
import { CloseIcon } from '../Icons/CloseIcon';

type CloseButtonProps = {
  onClick?: () => void;
};

export function CloseButton({ onClick }: CloseButtonProps) {
  return (
    <button
      onClick={onClick}
      aria-label="Close desktop navigation"
      className={clsx(
        'bg-transparent',
        'border-0',
        'cursor-pointer',
        'whitespace-nowrap',
        'absolute',
        'touch-manipulation',
        'select-none',
        'text-base',
        'leading-none',
        'min-w-min',
        'transition-colors',
        'duration-150',
        'p-2',
        'top-2',
        'right-2',
        'text-neutral-darkest',
        'z-[898]',
        'tap-highlight-transparent',
      )}
    >
      <CloseIcon />
    </button>
  );
}
